import Chance from 'chance';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
const chance = new Chance();
export const getFakeText = (fieldType) => {
    let val;
    switch (fieldType) {
        case `address`:
            val = {
                street: chance.address(),
                city: chance.city(),
                state: chance.state(),
                zip: chance.zip(),
                country: chance.country()
            };
            break;
        case `name`:
            val = {
                first: chance.first(),
                last: chance.last(),
                title: chance.prefix()
            };
            break;
        case `phone`:
            const fullNumber = chance.phone({
                formatted: false,
                country: `us`
            });
            // libphonenumber-js expects a country so that it can prepend a country code when parsing
            // Since this is just an example, having the very brief `1` (US) country code seems alright
            const parsedPhoneNumber = parsePhoneNumberFromString(fullNumber, `US`);
            val = {
                full: `${parsedPhoneNumber.countryCallingCode}${parsedPhoneNumber.nationalNumber}`,
                ext: parsedPhoneNumber.ext,
                area: parsedPhoneNumber.nationalNumber.slice(0, 3),
                number: parsedPhoneNumber.nationalNumber.slice(-7)
            };
            break;
        case `email`:
            const reasonableEmailDomains = [
                `yahoo.com`,
                `hotmail.com`,
                `gmail.com`
            ];
            // If you don't do this, the domain will be an absurdist string of characters
            const domain = chance.pickone(reasonableEmailDomains);
            val = {
                label: `link`,
                email: chance.email({
                    domain
                })
            };
            break;
        case `image`:
            val = `https://cdn1.cloud-database.co/sampleimages/${chance.integer({
                min: 1,
                max: 150
            })}.png`;
            break;
        case `file`:
            val = {
                id: `54c329fef8d5717221936e45`,
                filename: `${chance.word()}.${chance.pickone([
                    `gif`,
                    `jpg`,
                    `docx`,
                    `pdf`,
                    `xlsx`
                ])}`,
                field_key: `field_1`
            };
            break;
        case `connection`:
            val = [
                {
                    id: `54c329fef8d5717221936e45`,
                    identifier: chance.word()
                }
            ];
            break;
        case `boolean`:
            val = chance.bool();
            break;
        case `paragraph_text`:
            val = chance.sentence();
            break;
        default:
            val = chance.word();
            break;
    }
    return val;
};
